let jQueryInstance;

if (!jQueryInstance) {
  jQueryInstance = require('jquery');

  window.jQuery = jQueryInstance;
  window.$ = jQueryInstance;
  window.jquery = jQueryInstance;
}

export default jQueryInstance;
